<template>
	<section>
		<MainLayout>
			<div class="container">
				<div class="box text-center">
					<div class="">
						<b-avatar size="200px" variant="primary" :text="user.firstName.charAt(0)"></b-avatar>
					</div>
					<hr>
					<b-form @submit="onSubmit">
						<b-form-row>
							<b-form-group class="col" label="Nombres">
								<b-form-input
									v-model="editUser.firstName"
									type="text"
									required
								></b-form-input>
							</b-form-group>
							<b-form-group class="col" label="Apellidos">
								<b-form-input
									v-model="editUser.lastName"
									type="text"
									required
								></b-form-input>
							</b-form-group>
						</b-form-row>
						<b-form-row>
							<b-form-group class="col" label="Email">
								<b-form-input
									v-model="editUser.email"
									type="text"
									required
								></b-form-input>
							</b-form-group>
							<b-form-group class="col" label="Telefono">
								<b-form-input
									v-model="editUser.phone"
									type="text"
									required
								></b-form-input>
							</b-form-group>
						</b-form-row>
						<br>
						<b-button v-if="!loading" variant="primary" type="submit">Actualizar datos</b-button>
						<b-button v-else disabled variant="primary" type="submit"><b-spinner small /></b-button>
						<hr>
						<b-button variant="warning" v-b-modal.update-pass-modal>Cambiar contraseña</b-button>
					</b-form>
				</div>
			</div>
			<b-modal
				id="update-pass-modal"
				hide-footer
				centered
				no-close-on-backdrop
				no-close-on-esc
				>
					<b-form @submit="doUpdatePassword">
						<b-form-group label="Nueva contraseña">
							<b-form-input
								v-model="password"
								type="password"
								required
							/>
						</b-form-group>
						<b-form-group label="Repetir contraseña">
							<b-form-input
								v-model="repeatPassword"
								type="password"
								required
							/>
						</b-form-group>
						<hr>
						<div class="text-center">
							<b-button v-if="!loadingUpdatePass" variant="primary" type="submit">Actualizar contraseña</b-button>
							<b-button v-else disabled variant="primary" type="submit"><b-spinner small /></b-button>
						</div>
					</b-form>
			</b-modal>
		</MainLayout>
	</section>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import api from '../../../api.js'

export default {
	components: { MainLayout },
	data(){
		return {
			password : '',
			repeatPassword : '',
			loading : true,
			loadingUpdatePass : false,
			editUser : {
				firstName : this.$root.store.state.currentUser.firstName,
				lastName : this.$root.store.state.currentUser.lastName,
				phone : this.$root.store.state.currentUser.phone,
				email : this.$root.store.state.currentUser.email,
			}
		}
	},
	computed:{
		user(){
			return this.$root.store.state.currentUser
		}
	},
	methods:{
		doUpdatePassword(evt){
			evt.preventDefault();
			if (this.password === this.repeatPassword) {
				this.loading = true;
				api(this).post('/profile/update-passwd',{
					password:this.password
				}).then(() => {
					this.password = ''
					this.repeatPassword = ''
					this.loading = false;
					this.$root.showAlert('Contraseña actualizada')
					this.$root.$emit('bv::hide::modal', "update-pass-modal", evt.target)
				}).catch(this.$root.handleRequestError)
			}else{
				this.$root.showAlert('Las contraseñas no son iguales',{variant:'danger'})
			}
		},
	onSubmit(evt){
		evt.preventDefault();
		this.loading = true;
		api(this).put('/profile',this.editUser).then(() => {
			this.$root.store.setUserData({
				firstName : this.editUser.firstName,
				lastName : this.editUser.lastName,
				email : this.editUser.email,
				permissions : this.user.permissions
			})
			this.loading = false;
			this.$root.showAlert('Datos actualizados')
		}).catch(this.$root.handleRequestError)
	},
	fetchUser(){
		api(this).get('/profile').then((res) => {
			this.editUser = {...res.data}
			this.loading = false
		}).catch(this.$root.handleRequestError)
	},
  },
  mounted(){
	this.fetchUser()
  }
}
</script>

<style scoped>
	.container{
		max-width: 600px;
	}
</style>
